import LinkMail from './LinkMail';

export default LinkMail;
